import { useRef } from 'react'

import { useFinancialAccountState } from '@webapp/hooks'
import { FinancialAccountTypes } from '@webapp/platform/banking/entities/enums/FinancialAccountTypeEnum'
import { isScaTokenInsufficientError } from '@webapp/platform/banking/utils/isScaTokenInsufficientError'
import { useLongTermScaVerificationPresenter } from '../presenters/LongTermScaVerificationPresenter'

export const useScaVerifiedContent = ({
  onError = () => undefined,
}: {
  onError?: () => void
} = {}) => {
  const {
    financialAccountType,
    isLoadingFinancialAccountSetupState,
    isFinancialAccountSetUp,
  } = useFinancialAccountState()

  const isScaVerificationEnabled =
    financialAccountType === FinancialAccountTypes.AIRWALLEX_GBP

  const {
    data: { scaToken },
    states: { isLoading: isLoadingScaState },
    commands: { verifyIdentity },
  } = useLongTermScaVerificationPresenter({
    enabled: isScaVerificationEnabled && isFinancialAccountSetUp,
    onError,
  })

  const reverifiedScaToken = useRef<string | undefined>(undefined)

  const handleQueryError = (error: unknown) => {
    if (!isScaTokenInsufficientError(error)) return
    if (reverifiedScaToken.current === scaToken) return

    reverifiedScaToken.current = scaToken
    verifyIdentity()
  }

  const showLoader =
    isScaVerificationEnabled &&
    (isLoadingFinancialAccountSetupState || isLoadingScaState || !scaToken)
  const showScaPrompt =
    isScaVerificationEnabled && !isLoadingScaState && !scaToken

  return {
    data: { scaToken },
    commands: { verifyIdentity, handleQueryError },
    states: {
      showLoader,
      showScaPrompt,
      isVerified:
        !isLoadingFinancialAccountSetupState &&
        (!isScaVerificationEnabled || !!scaToken),
    },
  }
}
